<div class="modal-header">
    <h4 class="modal-title">Ferie</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">

    <div class="row my-2">
        <div class="col-12">
            <div class="btn-toolbar">
                <div ngbDropdown class="d-inline-block">
                    <button class="btn btn-primary btn-sm btn--menu me-2" id="periodSelect" ngbDropdownToggle>År: {{ selectedYear || '- vælg -' }}</button>
                    <div ngbDropdownMenu aria-labelledby="periodSelect">
                        <button *ngFor="let year of years" class="dropdown-item" (click)="onSelectYear(year)">{{ year }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="holidays?.length > 0" class="row">
        <div class="col">
                <table class="table table-hover table-striped table-sm table-frame__body">
                    <thead>
                        <tr>
                            <th>Medarbejder</th>
                            <th class="text-end">Uden løn</th>
                            <th class="text-end">Optjent {{ selectedYear - 1 }}</th>
                            <th class="text-end">Overført rest {{ selectedYear - 1 }}</th>
                            <th class="text-end">Afholdt</th>
                            <th class="text-end">Afholdt 6. uge</th>
                            <th class="text-end">Rest</th>
                            <th class="text-end">Planlagt</th>
                            <th class="text-end">Ikke planlagt</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let holiday of holidays; trackBy:trackByMid">
                            <td>{{ holiday.navn }}</td>
                            <td class="text-end">
                                <span *ngIf="userLevel < 4">{{ holiday.udenloen | time }}</span>
                                <input
                                    name="udenloen"
                                    class="holiday-input text-end"
                                    type="text"
                                    (change)="onInput(holiday, $event)"
                                    [value]="holiday.udenloen | time"
                                />
                            </td>
                            <td class="text-end">
                                <span *ngIf="userLevel < 4">{{ holiday.optjent | time }}</span>
                                <input
                                    name="optjent"
                                    class="holiday-input text-end"
                                    type="text"
                                    (change)="onInput(holiday, $event)"
                                    [value]="holiday.optjent | time"
                                />
                            </td>
                            <td class="text-end">{{ holiday.restSidsteAar | time }}</td>
                            <td class="text-end">{{ holiday.afholdt | time }}</td>
                            <td class="text-end">{{ holiday.afholdtUge6 | time }}</td>
                            <td class="text-end">{{ holiday.rest | time }}</td>
                            <td class="text-end">{{ holiday.planlagt | time }}</td>
                            <td class="text-end">{{ holiday.rest - holiday.planlagt | time }}</td>
                        </tr>
                    </tbody>
                </table>
        </div>
    </div>

</div>
